let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("yFU5h")).then(() => parcelRequire('cisEQ'));